export default {
  'zh-cn': [
    {
      info: 'excel导入文件',
      content: [
        '请在excel导入文件的“词库模板”sheet页，填写所有词库内容，请勿修改第一行名称，否则无法读取',
        'excel文件中，若词库名和同义词两列均为空，则系统不对导入文件做检测',
        'excel文件中，若词库名或同义词两列中有内容，则词库导入后，会将此次导入之前的词库内容全部替换，请谨慎检查',
      ],
    },
    {
      info: '目录',
      content: [
        '一级目录有三个特定名称，分别为：敏感词库、专有词库、任务引擎词库。请勿修改保留目录名称',
        '当一个父目录包含几个子目录时，表格中不需要在不同行多次填写父目录名称，只需要在第一个子目录的同一行填写一次',
        '目录之间不可有空白目录列。例如一级目录、二级目录、四级目录有内容，三级目录为空 —> 上传后会报错',
        '目录字数限制：1~20字',
        '目录名称可使用 * 开头，导入后 * 符号不会出现，且导入后该目录名称不可修改',
      ],
    },
    {
      info: '词语',
      content: [
        '词语字数限制：1~35字',
      ],
    },
    {
      info: '同义词',
      content: [
        '一组词需填写在“同义词”列的同一单元格中，使用逗号分隔',
        '同义词单元格字数限制：1~32767字（包括符号）',
        '每个词的字数限制：1~64字',
        '词语加所有同义词，总数不超过10000个',
        '词语和同义词不可以均为空',
      ],

    },
    {
      info: '其他',
      content: [
        '如果同义词单元格中有内容，二级目录、三级目录、四级目录对应单元格的内容可以为空，代表同义词属于此行最后一个不为空的目录',
        '如果同义词单元格中有内容，词语对应单元格的内容不可以为空；即同义词必须属于某个词库',
        '如果同义词单元格中无内容，二级目录、三级目录、四级目录和词语都可以为空；即只有分类结构，分类目录中没有词',
        '同义词中的每个词是系统最终识别的对象，词语和目录仅是分类名称。如需系统识别词语或者目录名，请将这些名称也填入同义词单元格中',
      ],
    },
  ],
  'zh-tw': [
    {
      info: 'excel導入文件',
      content: [
        '請在excel導入文件的“詞庫模板”sheet頁，填寫所有詞庫內容，請勿修改第一行名稱，否則無法讀取',
        'excel文件中，若詞庫名和同義詞兩列均為空，則系統不對導入文件做檢測',
        'excel文件中，若詞庫名或同義詞兩列中有內容，則詞庫導入後，會將此次導入之前的詞庫內容全部替換，請謹慎檢查',
      ],
    },
    {
      info: '目錄',
      content: [
        '一級目錄有三個特定名稱，分別為：敏感詞庫、專有詞庫、任務引擎詞庫。請勿修改保留目錄名稱',
        '當一個父目錄包含幾個子目錄時，表格中不需要在不同行多次填寫父目錄名稱，只需要在第一個子目錄的同一行填寫一次',
        '目錄之間不可有空白目錄列。例如一級目錄、二級目錄、四級目錄有內容，三級目錄為空 —> 上傳後會報錯',
        '目錄字數限制：1~20字',
        '目錄名稱可使用 * 開頭，導入後 * 符號不會出現，且導入後該目錄名稱不可修改',
      ],
    },
    {
      info: '詞語',
      content: [
        '詞語字數限制：1~35字',
      ],
    },
    {
      info: '同義詞',
      content: [
        '一組詞需填寫在“同義詞”列的同一單元格中，使用逗號分隔',
        '同義詞單元格字數限制：1~32767字（包括符號）',
        '每個詞的字數限制：1~64字',
        '詞語加所有同義詞，總數不超過10000個',
        '詞語和同義詞不可以均為空',
      ],

    },
    {
      info: '其他',
      content: [
        '如果同義詞單元格中有內容，二級目錄、三級目錄、四級目錄對應單元格的內容可以為空，代表同義詞屬於此行最後一個不為空的目錄',
        '如果同義詞單元格中有內容，詞語對應單元格的內容不可以為空；即同義詞必須屬於某個詞庫',
        '如果同義詞單元格中無內容，二級目錄、三級目錄、四級目錄和詞語都可以為空；即只有分類結構，分類目錄中沒有詞',
        '同義詞中的每個詞是系統最終識別的對象，詞語和目錄僅是分類名稱。如需系統識別詞語或者目錄名，請將這些名稱也填入同義詞單元格中',
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/modules/Wordbank/_data/wordbankImportDesc.js